import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { changeVisualizationContext, getVisualizationContext } from './../../MainMenu/OnlyCash/actions'
import PointsInformation from './PointsInformation'
import { Icon } from 'loyal-react'
import AriaModal from 'react-aria-modal'
import { withRouter } from 'react-router'
import RedirectCashStyle from 'App/MainMenu/OnlyCash/RedirectCashStyle'
import RedirectPointsStyle from 'App/MainMenu/OnlyCash/RedirectPointsStyle'
import yn from 'yn'

class UserBasicInformation extends Component {
  constructor (props) {
    super(props)

    this.state = {
      hideValue: false,
      isFlagChoiceOpened: false,
      cash: false,
      smallHeader: false,
      loaderCash: false,
      loaderPoints: false,
      onlyCash: this.props.onlyCash
    }
  }

  componentDidMount () {
    if (this.props.catalogJustCash) {
      this.props.getVisualizationContext()
      this.props.onlyCash && this.setState({ cash: this.props.onlyCash })
    } else {
      this.setState({ cash: false })
    }
    this.setState({ changeContext: false })

    window.onscroll = function () { scrollHeader() }

    const scrollHeader = () => {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        this.setState({ smallHeader: true })
      } else {
        this.setState({ smallHeader: false })
      }
    }
  }

  componentDidUpdate () {
    if (this.state.cash !== this.props.onlyCash) {
      this.setCash(this.props.onlyCash)
    }
  }

  setCash = value => this.setState({ cash: this.props.onlyCash })

  formatName = name => {
    return name.split(' ')[0]
  }

  formatPoints = (value) => {
    const decimal = Math.pow(10, this.props.decimalPlaces)

    const formated = Math.floor(parseFloat(value) * decimal) / decimal

    return (formated).toLocaleString('pt-br', {
      minimumFractionDigits: this.props.decimalPlaces || 0,
      maximumFractionDigits: this.props.decimalPlaces || 0
    })
  }

  hideValue = () => {
    window.localStorage.setItem('hideValue', !this.state.hideValue)
    this.setState({
      hideValue: !this.state.hideValue
    })
  }

  returnPoints = () => {
    return this.formatPoints(this.props.pointsValue) + ' ' + this.props.pointsName
  }

  maskedValue = () => {
    let hiddenPoints = this.returnPoints()

    return hiddenPoints.replace(/./g, '*')
  }

  openFlagArea = () => {
    this.setState({
      isFlagChoiceOpened: !this.state.isFlagChoiceOpened
    })
  }

  handleChangeField = type => {
    if (type === 'cash') {
      this.setState({ cash: true, loaderCash: true, loaderPoints: false })
      this.props.SetOnlyCash(true).then(() => {
        this.unsetLoaders()
      })
    } else {
      this.setState({ loaderPoints: true, loaderCash: false })
      this.props.SetOnlyCash(false).then(() => {
        this.unsetLoaders()
      })
    }
  }

  unsetLoaders = () => {
    window.location.href = '/'
    setTimeout(() => {
      this.setState({ loaderCash: false, loaderPoints: false })
    }, 2000)
  }
  render () {
    return (
      <Fragment>
        <div
          className={`container-points-toogle col-12 pos-relative t-5 mt-1 container-fluid border-top border-top-color-brand-3 container-header d-print-none user-basic-information`}
        >
          <div className='row align-items-center h-100'>
            <div className={`col pl-2 pr-0 txt-left pointer color-brand-5 ${!this.state.smallHeader ? 'props-small-header' : ''} small-header h-100`}>
              <span className={`txt-font-body txt-body-sm ${this.props.isLoading && 'd-flex align-items-center'}`}>
                {`${this.formatName(this.props.userInfo.name)}! `}
                {this.props.isLoading ? (
                  'Carregando pontuação'
                ) : (
                  <Fragment>
                    <PointsInformation
                      hideValue={this.state.hideValue}
                      maskedValue={this.maskedValue()}
                      formatPoints={this.returnPoints()}
                    />
                    <a
                      onClick={() => this.hideValue()}
                      href='javascript:void(0)'
                      role='button'
                      aria-label={window.localStorage.getItem('hideValue') === 'true' || this.state.hideValue ? 'Exibir pontuação' : 'Esconder pontuação'}
                      className='d-inline-block ml-1'
                    >
                      <Icon
                        iconName={window.localStorage.getItem('hideValue') === 'true' || this.state.hideValue ? 'icon_no_view' : 'icon_view'}
                        className='color-brand-5 txt-body-sm position-relative pos-relative l-0 t-0'
                      />
                      <span className='hide-absolute hide-points-toogle'>{this.state.isFlagChoiceOpened ? 'Fechar seleção do formato' : 'Selecionar formato de resgate' }</span>
                    </a>
                  </Fragment>
                )}
              </span>
            </div>

            {this.props.catalogJustCash &&
            <Fragment>
              {
                this.state.loaderCash && (
                  <AriaModal titleText='Recarregando' focusDialog='true' underlayStyle={{ zIndex: 9999 }}>
                    <div className='w-100 h-100' data-campaign={(this.props.userInfo && this.props.userInfo['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID}>
                      <div className={`loader-points-cash pos-fixed t-0 l-0 h-100`}>
                        <RedirectCashStyle />
                      </div>
                    </div>
                  </AriaModal>
                )
              }
              {
                this.state.loaderPoints && (
                  <AriaModal titleText='Recarregando' focusDialog='true' underlayStyle={{ zIndex: 9999 }}>
                    <div className='w-100 h-100' data-campaign={(this.props.userInfo && this.props.userInfo['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID}>
                      <div className={`loader-points-cash pos-fixed t-0 l-0 h-100`}>
                        <RedirectPointsStyle />
                      </div>
                    </div>
                  </AriaModal>
                )
              }
              {
                yn(process.env.REACT_APP_HEADER_CONTEXT_DEFAULT) && (
                  <div
                    className={`col pl-0 pr-2 txt-left pointer color-brand-5 ${!this.state.smallHeader ? 'not-props-small-header' : ''} small-header h-100`}
                  >
                    {this.state.cash ? (
                      <a
                        className='open-flag d-flex align-items-center m-0'
                        onClick={() =>
                          this.handleChangeField('points')
                        }
                        href='javascript:void(0)'
                        role='button'
                        aria-label='Compre com cartão'
                      >
                        Compre com pontos
                        <Icon
                          iconName='icon_right'
                          className='color-brand-5 txt-body-sm'
                        />
                        <span className='hide-absolute flag-choice'>Compre com pontos</span>
                      </a>
                    ) : (
                      <a
                        className='open-flag d-flex align-items-center m-0'
                        onClick={() =>
                          this.handleChangeField('cash')
                        }
                        href='javascript:void(0)'
                        role='button'
                        aria-label='Compre com pontos'
                      >
                        Compre com cartão
                        <Icon
                          iconName='icon_right'
                          className='color-brand-5 txt-body-sm'
                        />
                        <span className='hide-absolute flag-choice'>Compre com cartão</span>
                      </a>
                    )}
                  </div>
                )}
            </Fragment>
            }
          </div>
        </div>
      </Fragment>
    )
  }
}

UserBasicInformation.propTypes = {
  isLoading: PropTypes.bool,
  userInfo: PropTypes.object,
  pointsValue: PropTypes.number,
  pointsName: PropTypes.string,
  SetOnlyCash: PropTypes.func,
  catalogJustCash: PropTypes.bool,
  onlyCash: PropTypes.bool,
  getVisualizationContext: PropTypes.func,
  decimalPlaces: PropTypes.number
}

const mapStateToProps = ({ oidc, balance, catalog, onlyCash }) => ({
  userInfo: oidc.user.profile,
  isLoading: balance.isLoading,
  pointsValue: balance.pointsValue,
  pointsName: catalog.currencyConfiguration.pointsName,
  catalogJustCash: catalog.onlyCash,
  decimalPlaces: catalog.currencyConfiguration.decimalPlaces,
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  SetOnlyCash: cash => dispatch(changeVisualizationContext(cash)),
  getVisualizationContext: () => dispatch(getVisualizationContext())
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBasicInformation))



// WEBPACK FOOTER //
// ./src/App/Header/UserBasicInformation/UserBasicInformation.js